import { quickEntries } from "@/mocks/homeContent";

export default function QuickEntries() {
  return (
    <section id="entries" className="w-full bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-8">
        <div className="flex flex-col items-start justify-between gap-4 md:flex-row md:items-end">
          <div>
            <span className="inline-flex items-center gap-2 text-sm font-medium text-primary-700">
              <span className="h-px w-6 bg-primary-600"></span> 快速入口
            </span>
            <h2 className="mt-3 font-display text-2xl font-bold tracking-tight text-foreground-950 md:text-4xl">
              六大入口，各取所需
            </h2>
          </div>
          <p className="max-w-md text-sm leading-relaxed text-foreground-600">
            依据内容类型选择最贴合的通路，编辑部按标准流程受理，全程可追溯、可查询、可撤回。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {quickEntries.map((e, i) => (
            <a
              key={e.id}
              href="#contact"
              className="group relative overflow-hidden rounded-lg border border-background-200 bg-background-50 p-6 transition-colors hover:border-primary-300"
            >
              <span className="absolute right-5 top-5 font-display text-5xl font-black text-background-200 transition-colors group-hover:text-primary-200">
                {String(i + 1).padStart(2, "0")}
              </span>
              <span className="relative flex h-11 w-11 items-center justify-center rounded-md bg-primary-100 text-primary-700">
                <i className={`${e.icon} text-xl`}></i>
              </span>
              <span className="mt-4 inline-flex items-center gap-1 rounded-full bg-accent-100 px-2.5 py-1 text-xs text-accent-900">
                {e.tag}
              </span>
              <h3 className="mt-3 font-display text-lg font-bold text-foreground-950">{e.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{e.desc}</p>
              <span className="mt-4 inline-flex items-center gap-1 text-sm font-medium text-primary-700">
                进入通道
                <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1"></i>
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}